/* eslint-disable prefer-template */
const subtractLicense = (hostsArray) =>
{
	let total = 0;

	hostsArray.forEach((each) =>
	{
		if (each?.license !== -1)
		{
			total += each?.license;
		}
	});

	return total;
};

const getMyLicenses = (licenseArray, userInfo) =>
{
	const resultArray = [];

	licenseArray.forEach((each) =>
	{

		if (each?.licenseTo === userInfo?.userId)
		{
			if (each.hosts)
			{
				const subtractCount = subtractLicense(each.hosts);
				const remainingLicenseCount = each.licenseCount - subtractCount;

				resultArray.push({
					licenseName : each.licenseName + '_' + remainingLicenseCount,
					licenseObj  : each
				});
			}
			else
			{
				resultArray.push({
					licenseName : each.licenseName + '_' + each?.licenseCount,
					licenseObj  : each
				}
				);
			}
		}
		else
		{
			each?.hosts.map((eachH) =>
			{
				if (eachH?.email === userInfo?.email)
				{
					if (eachH?.license === -1)
					{
						const subtractCount = subtractLicense(each.hosts);
						const remainingLicenseCount = each.licenseCount - subtractCount;

						resultArray.push({
							licenseName : each.licenseName + '_' + remainingLicenseCount,
							licenseObj  : each
						});

					}
					else
					{
						resultArray.push({
							licenseName : each.licenseName + '_' + eachH?.license,
							licenseObj  : each
						});
					}

				}
			});
		}
	});

	return resultArray;
};

export default getMyLicenses;
